import { Address, DeliveryDateType, GenericObject, copyFields, fixDates } from '@synergy/models';

import { Contact } from './contact';
import { Customer } from './customer';
import { Offer } from './offer';
import { User } from './user';

export class AccountPurchase {
    public id?: number;
    public customerAccount!: Customer;
    public contact!: Contact;
    public avisoContact?: Contact;
    public deliveryAddress!: Address;
    public offers!: Offer[];
    public deliveryDate?: Date;
    public deliveryDateType?: DeliveryDateType;
    public createdBy!: User;
    public updateBy!: User;
    public createdAt!: Date;
    public updatedAt!: Date;

    public static fromPlainObject(object: GenericObject): AccountPurchase {
        const accountPurchase = new AccountPurchase();

        copyFields(object, accountPurchase);

        if (object['contact']) {
            accountPurchase.contact = Contact.fromPlainObject(object['contact']);
        }

        if (object['avisoContact']) {
            accountPurchase.avisoContact = Contact.fromPlainObject(object['avisoContact']);
        }

        if (object['deliveryAddress']) {
            accountPurchase.deliveryAddress = Address.fromPlainObject(object['deliveryAddress']);
        }

        if (object['customerAccount']) {
            accountPurchase.customerAccount = Customer.fromPlainObject(object['customerAccount']);
        }

        if (object['offers']) {
            accountPurchase.offers = object['offers'].map(Offer.fromPlainObject);
        }

        if (object['createdBy']) {
            accountPurchase.createdBy = User.fromPlainObject(object['createdBy']);
        }

        if (object['updateBy']) {
            accountPurchase.updateBy = User.fromPlainObject(object['updateBy']);
        }

        fixDates(accountPurchase, ['createdAt', 'updatedAt']);

        return accountPurchase;
    }
}
